// Typo Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

class Typo extends Component {
  static get propTypes () {
    return {
      alternate: PropTypes.bool,
      className: PropTypes.string,
      children: PropTypes.any
    }
  }

  static get defaultProps () {
    return {
      alternate: false,
      className: null,
      children: null
    }
  }

  render () {
    const classes = classnames(
      'typo',
      {
        typo_alt: this.props.alternate
      },
      this.props.className
    )

    return <div className={classes}>{this.props.children}</div>
  }
}

export default Typo
